module.exports = __webpack_public_path__ + "8fa82d2e4f0316885570988293d206b9.png";